export default __webpack_public_path__ + "static/media/2.172bd9d0.jpg";